<template>
    <div>
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-area type="fieldset">
                <rkm-row>
                    <rkm-col>
                        <rkm-form-input
                            :validations="validations.medicamento"
                            label="Medicamento"
                            v-model="model.medicamento.descricao"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-0">
                        <rkm-button
                            color="primary"
                            @click.stop="add()"
                            :label="false"
                        >
                            <template v-if="this.model.medicamento.id">
                                Salvar
                            </template>
                            <template v-else>
                                Incluir
                            </template>
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        <List
            :items="items"
            @edit="edit($event)"
        />
    </div>
</template>

<script>
// Components
import List from './List'

// Mixins
import { repository, object, error } from '@/mixins'

//Vuex
import { mapActions } from 'vuex'

export default {
    components: { List },
    computed: {
        fields() {
            return {
                autocomplete: {
                    medicamentoNaoPadronizado: [
                        { key: "descricao", searchable: true },
                    ],
                }
            }
        },
        validations() {

            return {
                medicamento: { required: true, min:3, max: 100 },
            }
        }
    },
    created() {

        this.repositories = {
            medicamentoNaoPadronizado: this.getConectaSusRepository('cadastro.medicamentoNaoPadronizado'),
        }
    },
    data: () => ({
        model: {
            medicamento: {
                id: null,
                descricao: null,
                deleted: false,
            },
        },
        modelMedicamentoDefault: {
            id: null,
            descricao: null,
            deleted: false,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    const medicamento = this.clone(this.model.medicamento)

                    if (medicamento.id) {

                        const idx = this.items.findIndex(i => i.id === medicamento.id)
                        Object.assign(this.items[idx], medicamento)

                    } else {

                        const itemFind = this.items.find(i => i.descricao.trim() === medicamento.descricao.trim())

                        if (itemFind) {

                            this.showValidationNotification("Esse medicamento já existe na lista!")

                            return
                        }

                        medicamento.id = `${new Date().getTime()}-medicamento-nao-padronizado`

                        this.items.push(medicamento)
                    }

                    this.model.medicamento = this.clone(this.modelMedicamentoDefault)
                    this.$refs.RkmForm.resetValidator()
                })
        },
        save() {

            if (this.items.length > 0) {

                this.setLoading()

                const params = this.items.map(item => {

                    item.id = Number.isInteger(item.id) ? item.id : null
                    return item
                })

                this.repositories.medicamentoNaoPadronizado.store(params)
                    .then(({ data }) => {

                        this.$emit('save', data)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        edit(item) {

            this.model.medicamento = this.clone(item)
        }
    },
    mixins: [repository, object, error],
    props: {
        items: { type: Array, default: () => [] },
    }
}
</script>